import { useState, useEffect } from "react";
import { useRequest } from "ahooks";
import { Table, Space, Input, Select, DatePicker, Tag } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import moment from "moment";
import { Link } from "react-router-dom";
import {
  message as messageService,
  setting as settingService,
} from "@/services";
import { useAuthContext } from "@/components/auth/AuthProvider";
import MessagePublishButton from "./MessagePublishButton";
import MessageEditButton from "./MessageEditButton";
import MessageDeleteButton from "./MessageDeleteButton";

import styles from "./index.module.less";

function DraftMessage() {
  const [version, setVersion] = useState(Date.now());
  const [type, setType] = useState();
  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();
  const [keyword, setKeyword] = useState();
  const [pageSize, setPageSize] = useState(50);
  const [page, setPage] = useState(1);
  const auth = useAuthContext();
  const { data: types = { results: [] }, loading: messageTypeLoading } =
    useRequest(() => settingService.listMessageType({}, auth.token), {
      ready: !!auth.token,
      refreshDeps: [auth.token],
    });
  const {
    data = { total: 0, results: [] },
    loading,
    run,
  } = useRequest(
    (params, token) => {
      return messageService.listMyDraftMessage(params, token);
    },
    {
      manual: true,
    }
  );

  useEffect(() => {
    if (auth) {
      run(
        {
          version,
          type,
          start_date: startDate,
          end_date: endDate,
          search: keyword,
          page,
          page_size: pageSize,
        },
        auth.token
      );
    }
  }, [run, auth, keyword, page, pageSize, version, type, startDate, endDate]);

  const columns = [
    {
      title: "序号",
      key: "num",
      width: 50,
      render: (text, record, index) => `${index + 1}`,
    },
    {
      title: "类型",
      key: "messageType",
      width: 100,
      render: (record) => record.type.name,
    },
    {
      title: "标题",
      dataIndex: "title",
      render: (text, record) => (
        <Link to={`/workshop/msubm/detail/${record.id}`}>{text}</Link>
      ),
    },
    {
      title: "日期",
      width: 160,
      dataIndex: "published_at",
      render: (text, record) => moment(text).format("YYYY-MM-DD HH:mm"),
    },
    {
      title: "批示",
      width: 120,
      dataIndex: "bounce_comment",
    },
    {
      title: "状态",
      width: 100,
      dataIndex: "status",
      render: (text, record) => {
        if (record.status === 0) return <Tag color="warning">草稿</Tag>;
        else return <Tag color="processing">已提交</Tag>;
        // if (record.status === 1) return <Tag color="processing">已上报</Tag>;
        // if (record.status === 3 || record.status === 4)
        //   return <Tag color="success">{`已处理（${record.status_name}）`}</Tag>;
        // if (record.status === 5)
        //   return <Tag color="error">{`已处理（${record.status_name}）`}</Tag>;
        // if (record.status === 2) return <Tag color="processing">已处理</Tag>;
      },
    },
    {
      title: "操作",
      key: "operation",
      width: 100,
      align: "right",
      render: (record) =>
        record.status === 0 ? (
          <Space size="small">
            <MessagePublishButton
              messageId={record.id}
              callback={setVersion}
              title={record.title}
              sendee={record.sendee.name}
            />
            <MessageEditButton messageId={record.id} callback={setVersion} />
            <MessageDeleteButton messageId={record.id} callback={setVersion} />
          </Space>
        ) : (
          "-"
        ),
    },
  ];
  return (
    <div className={styles.draftMessage}>
      <div className="table-toolbar">
        <div className="left"></div>
        <div className="right">
          <Space>
            <div>
              类型：
              <Select
                style={{ width: 120 }}
                loading={messageTypeLoading}
                onChange={(value) => setType(value)}
                allowClear
              >
                {types.results.map((t) => (
                  <Select.Option key={`type-${t.id}`} value={t.id}>
                    {t.name}
                  </Select.Option>
                ))}
              </Select>
            </div>
            <div>
              日期：
              <DatePicker.RangePicker
                allowClear
                disabledDate={(current) => current.isAfter(moment())}
                onChange={(value) => {
                  setStartDate(value[0].format("YYYY-MM-DD"));
                  setEndDate(value[1].format("YYYY-MM-DD"));
                }}
              />
            </div>
            <div>
              标题：
              <Input
                prefix={<SearchOutlined style={{ color: "#ccc" }} />}
                style={{ width: 220 }}
                placeholder="搜索内容"
                allowClear
                onChange={(e) => setKeyword(e.target.value)}
              />
            </div>
          </Space>
        </div>
      </div>
      <Table
        rowKey="id"
        size="middle"
        columns={columns}
        dataSource={data.results}
        loading={loading}
        pagination={{
          pageSize: pageSize,
          total: data.count,
        }}
        onChange={({ current, pageSize }) => {
          setPage(current);
          setPageSize(pageSize);
        }}
      />
    </div>
  );
}

export default DraftMessage;
